export const SET_CREDIT_BALANCE = 'SET_CREDIT_BALANCE';

export const SET_TALKS = 'SET_TALKS';
export const LOAD_MORE_TALKS = 'LOAD_MORE_TALKS';
export const SET_TALKS_META = 'SET_TALKS_META';
export const DELETE_TALK = 'DELETE_TALK';
export const SET_ACTIVE_TALK_ID = 'SET_ACTIVE_TALK_ID';
export const SET_ACTIVE_TALK = 'SET_ACTIVE_TALK';

export const UPDATE_TALK = 'UPDATE_TALK';

export const OPEN_UZAIR = 'OPEN_UZAIR';
export const CLOSE_UZAIR = 'CLOSE_UZAIR';

export const HARD_CLOSE_UZAIR = 'HARD_CLOSE_UZAIR';

export const CLEAR_UZAIR_POPUP_CONFIG = 'CLEAR_UZAIR_POPUP_CONFIG';

export const ADD_RESPONSE_TRANSFER_MEMORY = 'ADD_RESPONSE_TRANSFER_MEMORY';

export const TOGGLE_UZAIR_ICON = 'TOGGLE_UZAIR_ICON';

export const MINIMIZE_UZAIR = 'MINIMIZE_UZAIR';

export const CREATE_EVENT = 'CREATE_EVENT';
export const REMOVE_EVENT = 'REMOVE_EVENT';
export const MAKE_IT_IN_PROGRESS_EVENT = 'MAKE_IT_IN_PROGRESS_EVENT';

export const TOGGLE_THEME_MODE = 'TOGGLE_THEME_MODE';

export const SET_ACTIVE_CHAT_ID = 'SET_ACTIVE_CHAT_ID';

export const SET_UZAIR_ADMIN_MODE = 'SET_UZAIR_ADMIN_MODE';

export const UPDATE_UZAIR_APP_KEY = 'UPDATE_UZAIR_APP_KEY';

export const SET_UZAIR_PROGRESS_STATUS = 'SET_UZAIR_PROGRESS_STATUS';
